import { PRIVACY_POLICY_VERSION } from '../../analytics/versions';
import type { ConsentStatus } from '../../analytics/consent';

/**
 * The date the current privacy policy took effect (set in analytics/versions.ts). Recruiters who
 * accepted before this date are shown the privacy window once more.
 */
export const PRIVACY_POLICY_UPDATED_AT = PRIVACY_POLICY_VERSION;

/** Which sections of the privacy window to show; nothing at all when both are false. */
export const privacyPromptSections = ({
  termsAcceptedAt,
  consentStatus,
  impersonating,
  policyUpdatedAt = PRIVACY_POLICY_UPDATED_AT,
}: {
  termsAcceptedAt?: string | Date | null;
  consentStatus: ConsentStatus;
  impersonating: boolean;
  policyUpdatedAt?: string;
}) => {
  // Hubert staff acting as a customer must not accept a newer policy on the customer's behalf and
  // are never asked for, or counted in, analytics: for them the window only appears, as before,
  // for accounts that never accepted the policy.
  if (impersonating) return { policy: !termsAcceptedAt, analytics: false };

  const accepted = termsAcceptedAt ? new Date(termsAcceptedAt).getTime() : NaN;
  const outdated = !(accepted >= new Date(policyUpdatedAt).getTime());
  // The window (analytics question plus policy link) opens when the policy is new to this recruiter
  // or no analytics choice has been made on this browser; answering it also records the policy.
  const show = outdated || consentStatus === 'pending';
  const policy = show;
  const analytics = show;
  return { policy, analytics };
};
